var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { default as styled, css } from 'styled-components';
import { resets } from '../utils';
var spanResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"], ["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"])), resets.normalize.html, resets.common);
var Span = function (props) { return React.createElement("span", __assign({}, props)); };
export var HtmlSpan = styled(Span)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), spanResets);
var templateObject_1, templateObject_2;
//# sourceMappingURL=HtmlSpan.js.map